import { useCallback } from 'react'
import { usePostHog } from '@posthog/react'
import { isPostHogEnabled } from '@/lib/posthog'

export interface UseAnalyticsResult {
  capture: (event: string, properties?: Record<string, unknown>) => void
  identify: (userId: string, properties?: Record<string, unknown>) => void
  register: (properties: Record<string, unknown>) => void
  reset: () => void
}

export function useAnalytics(): UseAnalyticsResult {
  const posthog = usePostHog()

  const capture = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      if (!isPostHogEnabled) return
      posthog.capture(event, properties)
    },
    [posthog],
  )

  const identify = useCallback(
    (userId: string, properties?: Record<string, unknown>) => {
      if (!isPostHogEnabled) return
      posthog.identify(userId, properties)
    },
    [posthog],
  )

  const register = useCallback(
    (properties: Record<string, unknown>) => {
      if (!isPostHogEnabled) return
      posthog.register(properties)
    },
    [posthog],
  )

  const reset = useCallback(() => {
    if (!isPostHogEnabled) return
    posthog.reset()
  }, [posthog])

  return { capture, identify, register, reset }
}
